import { useState } from "react";
import { NavigationMenu, NavigationMenuList, NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent, NavigationMenuLink, navigationMenuTriggerStyle } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu } from "lucide-react";

export default function PublicHeader() {
  const [open, setOpen] = useState(false);
  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-slate-950/80 backdrop-blur border-b border-slate-800">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        <a href="#inicio" className="flex items-center gap-3">
          <img src="/logo-fundo-branco.png" alt="Caixa Fácil Já" className="h-8 w-auto" />
          <span className="font-semibold text-white">Caixa Fácil Já</span>
        </a>
        <div className="hidden lg:flex items-center gap-6">
          <NavigationMenu>
            <NavigationMenuList>
              <NavigationMenuItem>
                <NavigationMenuTrigger>Visão Geral</NavigationMenuTrigger>
                <NavigationMenuContent>
                  <div className="grid gap-2 p-4 w-[420px]">
                    <a className={navigationMenuTriggerStyle()} href="/#inicio">Início</a>
                    <a className={navigationMenuTriggerStyle()} href="/#painel">Painel</a>
                    <a className={navigationMenuTriggerStyle()} href="/#cta">Chamada Final</a>
                  </div>
                </NavigationMenuContent>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuTrigger>Recursos</NavigationMenuTrigger>
                <NavigationMenuContent>
                  <div className="grid gap-2 p-4 w-[520px] grid-cols-2">
                    <a className={navigationMenuTriggerStyle()} href="/#gestao-caixa">Caixa e Registros</a>
                    <a className={navigationMenuTriggerStyle()} href="/#gestao-negocio">Cadastros Principais</a>
                    <a className={navigationMenuTriggerStyle()} href="/#tudo-que-faz">Modais de Cadastros</a>
                    <a className={navigationMenuTriggerStyle()} href="/#controles-avancados">Configurações</a>
                    <a className={navigationMenuTriggerStyle()} href="/#raio-x">Raio‑X</a>
                    <a className={navigationMenuTriggerStyle()} href="/#chatwoot">Chatwoot + WhatsApp</a>
                  </div>
                </NavigationMenuContent>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink className={navigationMenuTriggerStyle()} href="/#planos">Planos</NavigationMenuLink>
              </NavigationMenuItem>
              <NavigationMenuItem>
                <NavigationMenuLink className={navigationMenuTriggerStyle()} href="/#quem-usa">Quem usa</NavigationMenuLink>
              </NavigationMenuItem>
            </NavigationMenuList>
          </NavigationMenu>
          <a href="/auth" className="text-sm text-white">Entrar</a>
          <Button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>Começar</Button>
        </div>
        <button className="lg:hidden text-white" aria-label="Abrir menu" onClick={() => setOpen(!open)}>
          <Menu className="h-6 w-6" />
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-800 bg-slate-950">
          <nav className="container mx-auto px-4 py-4 grid gap-3">
            <a href="/#inicio" className="text-white">Início</a>
            <a href="/#painel" className="text-white">Visão Geral</a>
            <a href="/#gestao-caixa" className="text-white">Caixa e Registros</a>
            <a href="/#gestao-negocio" className="text-white">Cadastros Principais</a>
            <a href="/#tudo-que-faz" className="text-white">Modais de Cadastros</a>
            <a href="/#controles-avancados" className="text-white">Configurações</a>
            <a href="/#raio-x" className="text-white">Raio‑X</a>
            <a href="/#chatwoot" className="text-white">Chatwoot + WhatsApp</a>
            <a href="/#quem-usa" className="text-white">Quem usa</a>
            <a href="/#planos" className="text-white">Planos</a>
            <a href="/auth" className="text-white">Entrar</a>
            <Button onClick={() => { setOpen(false); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Começar</Button>
          </nav>
        </div>
      )}
    </header>
  );
}
